/** Busca un valor del wire en un mapa por enum; `undefined` si el backend mandó uno que no conoce. */
export function wireLookup<V>(
    map: Readonly<Partial<Record<string, V>>>,
    value: string,
): V | undefined {
    return Object.hasOwn(map, value) ? map[value] : undefined;
}
